export default class RpaTransactionTypes {
  static BOTH = "both";

  static INCOME = "income";

  static EXPENSES = "expenses";
}
